export default "__VITE_ASSET__0c15c219__"